// extracted by mini-css-extract-plugin
export default {"matchInfo":"MatchInfo_matchInfo__oqo2j","info":"MatchInfo_info__iefaW","label":"MatchInfo_label__hR0f1","value":"MatchInfo_value__JyzBM"};